import { ReactComponent as LogoutSvg } from '../../assets/icons/logout.svg';

export const LogoutIcon: SvgIcon = (props) => {
    return <LogoutSvg {...props} />;
};
